import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetInfoHandlerType = CustomHandler;

export const ResetWidgetInfo: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/Reset",
    });
};

export const chain = [ResetWidgetInfo];

const resetPerformanceWidgetInfo = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetPerformanceWidgetInfo");

export default resetPerformanceWidgetInfo;
